/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_RedirectingInputs */

const en_support_redirecting = /** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiating Checkout...`)
};

const es_support_redirecting = /** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando Pago...`)
};

const fr_support_redirecting = /** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancement du paiement...`)
};

const de_support_redirecting = /** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasse wird initiiert...`)
};

const id_support_redirecting = /** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memulai Checkout...`)
};

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const ja_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const zh_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const ar_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const it_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const ru_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const pt_support_redirecting = en_support_redirecting;

/** @type {(inputs: Support_RedirectingInputs) => LocalizedString} */
const ko_support_redirecting = en_support_redirecting;

/**
* | output |
* | --- |
* | "Initiating Checkout..." |
*
* @param {Support_RedirectingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_redirecting = /** @type {((inputs?: Support_RedirectingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_RedirectingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_redirecting(inputs)
	if (locale === "es") return es_support_redirecting(inputs)
	if (locale === "fr") return fr_support_redirecting(inputs)
	if (locale === "de") return de_support_redirecting(inputs)
	if (locale === "ja") return ja_support_redirecting(inputs)
	if (locale === "zh") return zh_support_redirecting(inputs)
	if (locale === "ar") return ar_support_redirecting(inputs)
	if (locale === "id") return id_support_redirecting(inputs)
	if (locale === "it") return it_support_redirecting(inputs)
	if (locale === "ru") return ru_support_redirecting(inputs)
	if (locale === "pt") return pt_support_redirecting(inputs)
	return ko_support_redirecting(inputs)
});